import React from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import ManageQuestions from '../../components/quiz/manage-questions.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const QuizQuestionsView = () => {
  const { id } = useParams();
  const pageTitle = PAGE_TITLE_LIST.QUIZ_MANAGE_QUESTIONS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ManageQuestions id={id} />
    </AppLayout>
  );
};

export default QuizQuestionsView;
